import { useState, useContext } from "react";
import Icon from "components/shared/Icon";
import Heading, { HEADING_TYPES } from "./Heading";
import { Context } from "Context";

const Accordion = ({ title, modifier, children }) => {
	const mainClass = "help-accordion";
	const { group } = useContext(Context);
	let classes = mainClass;
	if (modifier) classes += ` ${mainClass}--${modifier}`;
	const type = group === "faq" ? HEADING_TYPES.h3 : HEADING_TYPES.h2;
	const [open, setOpen] = useState(false);
	const ariaControls = title ? `${title.toString().toLowerCase().replace(/ /g,'-')}-content` : null;

	return (
		<div className={classes}>
			<button
				aria-expanded={open}
				className={`${mainClass}__heading`}
				onClick={() => setOpen(!open)}
				aria-controls={ariaControls}
			>
				<Icon icon={"norgie-closed"} rotate={open} />

				<Heading
					content={title}
					className={`${mainClass}__title`}
					aria-label={title}
					type={type}
				/>
			</button>
			<ul id={ariaControls}
				className={`${mainClass}__content ${
					open ? `${mainClass}__content--show` : ""
				}`}
			>
				{children}
			</ul>
		</div>
	);
};

export default Accordion;
